export default __webpack_public_path__ + "static/media/application.7ea4bb2c.svg";